module.exports = __webpack_public_path__ + "static/4-c47940a9309e36b4c3d6fe7b26ce0894.jpg";